import * as Graphql from "@hireroo/graphql/client/urql";
import { ScoringPrecisionFeedbackForm } from "@hireroo/validator";

export const generateReasonCategories = (
  fields: ScoringPrecisionFeedbackForm.ScoringPrecisionFeedbackFormSchema,
): Graphql.SpotFeedbackReasonCategory[] => {
  const reasonCategories: Graphql.SpotFeedbackReasonCategory[] = [];
  fields.categoryReasons?.forEach(reason => {
    switch (reason) {
      case "UNCLEAR_CRITERIA": {
        fields.unclearCriteriaReasons?.forEach(unclaerCriteriaReason => {
          switch (unclaerCriteriaReason) {
            case "CORRECTNESS": {
              reasonCategories.push(Graphql.SpotFeedbackReasonCategory.UnclearCriteriaCorrectness);
              break;
            }
            case "READABILITY": {
              reasonCategories.push(Graphql.SpotFeedbackReasonCategory.UnclearCriteriaReadability);
              break;
            }
            case "PERFORMANCE": {
              reasonCategories.push(Graphql.SpotFeedbackReasonCategory.UnclearCriteriaPerformance);
              break;
            }
            case "AVAILABILITY": {
              reasonCategories.push(Graphql.SpotFeedbackReasonCategory.UnclearCriteriaAvailability);
              break;
            }
            case "SCALABILITY": {
              reasonCategories.push(Graphql.SpotFeedbackReasonCategory.UnclearCriteriaScalability);
              break;
            }
            default: {
              throw new Error(`Invalid reason category ${unclaerCriteriaReason satisfies never}`);
            }
          }
        });
        break;
      }
      case "INSUFFICIENT_CRITERIA": {
        reasonCategories.push(Graphql.SpotFeedbackReasonCategory.InsufficientCriteria);
        break;
      }
      case "UNCLEAR_CHART": {
        reasonCategories.push(Graphql.SpotFeedbackReasonCategory.UnclearCharts);
        break;
      }
      case "SYSTEM_ERROR": {
        reasonCategories.push(Graphql.SpotFeedbackReasonCategory.SystemError);
        break;
      }
      case "INSUFFICIENT_CHEAT_DETECTION": {
        reasonCategories.push(Graphql.SpotFeedbackReasonCategory.InsufficientCheatDetection);
        break;
      }
      case "OTHER": {
        reasonCategories.push(Graphql.SpotFeedbackReasonCategory.Other);
        break;
      }
      default: {
        throw new Error(`Invalid reason category ${reason satisfies never}`);
      }
    }
  });
  return reasonCategories;
};
